import React, { FC } from 'react';
import { ListItem, ListItemButton, ListItemText } from '@mui/material';
import { MobileMenuItemProps } from '../../../../../models/NavigationMenuItem';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import useMobileMenu from '../../../../../hooks/useMobileMenu';
import { getCollectionHandle } from '../../../../../utils/utils';
import { useTranslation } from 'react-i18next';

export const MobileNavigationItem: FC<MobileMenuItemProps> = (props) => {
    const menuItem = props.menuItem;
    const navigate = useNavigate();
    const mobileMenu = useMobileMenu();
    const { t } = useTranslation();

    const goToCollection = () => {
        switch (menuItem.type) {
            case 'PAGE':
                window.location.replace(menuItem.url);
                break;
            case 'ROUTE':
                navigate(menuItem.url);
                break;
            case 'COLLECTION':
                navigate('collections/' + getCollectionHandle(menuItem.url));
                break;
            default:
                props.clickHandler(false, menuItem);
        }
        mobileMenu.closeAllMobileMenu();
    };

    if (props.isParent) {
        return (
            <ListItem
                disablePadding
                onClick={() => {
                    props.clickHandler(true, menuItem);
                }}
            >
                <ListItemButton>
                    <ArrowBackIcon />
                    <ListItemText
                        primary={
                            menuItem.translateTitle
                                ? t(menuItem.title)
                                : menuItem.title
                        }
                    />
                </ListItemButton>
            </ListItem>
        );
    }

    return (
        <>
            {menuItem.items && menuItem.items.length > 0 && (
                <ListItem
                    disablePadding
                    onClick={() => {
                        props.clickHandler(false, menuItem);
                    }}
                >
                    <ListItemButton>
                        <ListItemText
                            primary={
                                menuItem.translateTitle
                                    ? t(menuItem.title)
                                    : menuItem.title
                            }
                        />
                        {menuItem.items && menuItem.items.length > 0 && (
                            <ArrowForwardIosIcon />
                        )}
                    </ListItemButton>
                </ListItem>
            )}
            {(!menuItem.items || menuItem.items.length == 0) && (
                <ListItem disablePadding onClick={goToCollection}>
                    <ListItemButton>
                        <ListItemText
                            primary={
                                menuItem.translateTitle
                                    ? t(menuItem.title)
                                    : menuItem.title
                            }
                        />
                    </ListItemButton>
                </ListItem>
            )}
        </>
    );
};
